import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Navigation, Footer } from "@/components/sections";

export const NutzungsbedingungenPage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Nutzungsbedingungen - ForestHub</title>
        <meta name="description" content="Nutzungsbedingungen von ForestHub" />
      </Helmet>
      
      <Navigation onRequestDemo={() => {}} />
      
      <div className="pt-28 pb-24 max-w-3xl mx-auto px-6">
        <h1 
          className="text-3xl font-semibold text-stone-900 mb-8" 
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('legal.terms.title')}
        </h1>
        
        <div className="prose prose-stone max-w-none">
          <p className="lead">{t('legal.terms.intro')}</p>
          
          <h2>{t('legal.terms.scope')}</h2>
          <p>{t('legal.terms.scopeText')}</p>
          
          <h2>{t('legal.terms.operator')}</h2>
          <p>
            <strong>Hodema edertools AB</strong><br />
            Kyrkvägen 66<br />
            88372 Backe, Sweden
          </p>
          
          <h2>{t('legal.terms.service')}</h2>
          <p>{t('legal.terms.serviceText')}</p>
          
          <h2>{t('legal.terms.registration')}</h2>
          <p>{t('legal.terms.registrationText')}</p>
          
          <h2>{t('legal.terms.duties')}</h2>
          <p>{t('legal.terms.dutiesText')}</p>
          
          <h2>{t('legal.terms.liability')}</h2>
          <p>{t('legal.terms.liabilityText')}</p>
          
          <h2>{t('legal.terms.ip')}</h2>
          <p>{t('legal.terms.ipText')}</p>
          
          <h2>{t('legal.terms.termination')}</h2>
          <p>{t('legal.terms.terminationText')}</p>
          
          <h2>{t('legal.terms.law')}</h2>
          <p>{t('legal.terms.lawText')}</p>
          
          <h2>{t('legal.terms.changes')}</h2>
          <p>{t('legal.terms.changesText')}</p>
          
          <h2>{t('legal.terms.contact')}</h2>
          <p>{t('legal.terms.contactText')} <a href="mailto:info@hodema.se">info@hodema.se</a></p>
        </div>
        
        <div className="mt-12">
          <a href="/" className="text-[#1B4D3E] font-medium hover:underline">
            ← {t('legal.terms.back')}
          </a>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};
